import { BillingSubscriptionDto } from '../billing-subscription';
import { CurrencyDto } from "../currency.dto";
import { VATRateDto } from "../vat-rate.dto";
import { BaseDto } from '../base.dto';

export class BillingSubscriptionPriceDto extends BaseDto {
  billingSubscriptionId: number;
  currencyId: number;
  vatRateId: number;
  price: number;
  effectiveFrom: string;
  trialDays: number;
  billingSubscription?: BillingSubscriptionDto;
  currency?: CurrencyDto;
  vatRate?: VATRateDto;
}
